import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import { PiUsersThreeLight } from "react-icons/pi";

import { text } from "../../text";
import { URLS } from "../../config";
import { hooks } from "../../hooks";
import { utils } from "../../utils";
import { svg } from "../../assets/svg";
import { theme } from "../../constants";
import { components } from "../../components";
import { course as elements } from "../../course";
import { review as reviews } from "../../reviews";

import categoriesdata from "../../staticdata/categories";
import properties from "../../staticdata/properties";
import { reviewsData } from "../../staticdata/reviewData";
import { CourseCard } from "../../course/CourseCard";
import { SerachResultCard } from "../../course/SerachResultCard";
import { FilterSvg } from "../../assets/svg/FilterSvg";
import homeimg from "../../assets/nestfin/home.png";
// import logo from "../../assets/nestfin/NexfinPng.png"
import logo from "../../assets/nestfin/Nestfin_logo.png";
import { BottomTabBar } from "../../navigation/BottomTabBar";
import serachBanner from "../../assets/nestfin/Search_section.png";

import fallBackImg from "../../assets/nestfin/No_image_Found.png";

import {
  fetchPropertyByFilters,
  formatIndianNumber,
  updateLeadProfile,
  viewLeadProfile,
} from "../../environment";
import useApi from "../../customHook/useApi";
import { callService } from "../../customHook/callService";
import { CustomLoader } from "../../components/CustomLoader";
import { ImageWithLoader } from "../../course/ImageWithLoader";

export interface Feature {
  feature_id: number;
  feature_name: string;
  icon: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  photos: any; // can refine this later
  minimum_rent: number;
  gender_allowed: string;
  category: string;
  is_meal_provided?: string | null;
}

export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
}

type Profile = {
  leadId: string | null;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;
};

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  message?: string;
}

const buttonTagStyle = {
  backgroundColor: "var(--primary-color)",
  padding: "4px 8px",
  borderRadius: "5px",
  color: "white",
  cursor: "pointer",
  fontSize: "9px",
  letterSpacing: "1px",
};

export const Home2: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [activeIndex, setActiveIndex] = useState(0);
  const [coursesData, setCoursesData] = useState([]);
  const [bannersData, setBannersData] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState<string[]>([]);
  const [selectedLatLng, setSelectedLatLng] = useState<
    { lat: number; lng: number }[]
  >(() => {
    const stored = localStorage.getItem("selectedLatLng");
    return stored ? JSON.parse(stored) : [];
  });

  const [paramsData, setParamsData] = useState<any>(null);
  const [visibleCount, setVisibleCount] = React.useState(20);

  // const [categoriesData, setCategoriesData] = useState < any > [];
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [filterAPI, setFilterAPI] = useState<{
    leadId: string;
    selectedLocalityId: string;
    genderAPI: string;
    minAmount: number;
    maxAmount: number;
    selectedLatLng: any;
    category: string;
  }>({
    leadId: "",
    selectedLocalityId: "",
    genderAPI: "",
    minAmount: 2000,
    maxAmount: 8000,
    selectedLatLng: [],
    category: "",
  });

  // API CALL for show the data with filter
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // ***************HANDLE PARAMS
  useEffect(() => {
    const fetchData = async () => {
      // console.log("Param USE EFFECT top ");
      const params = new URLSearchParams(window.location.search);
      const dataParam = params.get("data");

      if (dataParam) {
        try {
          const parsedData = JSON.parse(dataParam);
          setParamsData(parsedData);

          // ✅ Save city info to localStorage
          if (parsedData?.cityName) {
            localStorage.setItem("selectedCity", parsedData.cityName);
          }
          if (parsedData?.cityId) {
            localStorage.setItem("selectedCityId", parsedData.cityId);
          }

          // ✅ Use searchText to fetch coordinates (awaited)
          // if (parsedData?.searchText) {
          //   await fetchLatLongAndSave(parsedData.searchText);
          //     console.log("Param USE EFFECT fetchLatLongAndSave ");
          // }
          if (parsedData?.searchText) {
            fetchLatLongAndSave(parsedData.searchText).then((coords: any) => {
              setSelectedLocality([parsedData.searchText]);
              setSelectedLatLng(coords);
            });
          }
        } catch (err) {
          console.error("Invalid data format:", err);
        }
      }
    };

    // 🗺️ Function to fetch lat/lng and save in sessionStorage
    const fetchLatLongAndSave = async (
      address: string,
    ): Promise<{ lat: number; lon: number }[] | null> => {
      try {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

        const res = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            address,
          )}&key=${apiKey}`,
        );

        const data: {
          status: string;
          results: {
            geometry: {
              location: { lat: number; lng: number };
            };
          }[];
        } = await res.json();

        if (data.status === "OK" && data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;

          const newCoords: any = [{ lat, lon: lng }];

          // Save updated values in localStorage
          localStorage.setItem("selectedLocality", JSON.stringify([address]));
          localStorage.setItem("selectedLatLng", JSON.stringify(newCoords));

          // IMPORTANT: update React state so API uses NEW data
          setSelectedLocality([address]);
          setSelectedLatLng(newCoords);

          return newCoords;
        }

        console.error("Geocoding API error:", data.status);
        return null;
      } catch (err) {
        console.error("Error fetching lat/lng:", err);
        return null;
      }
    };

    fetchData();
  }, [window.location.search]);

  // useEffect(() => {
  //   // if (selectedLocality.length === 0) return;
  //   // if (selectedLatLng.length === 0) return;

  //   const leadId = localStorage.getItem("lead_profile_id") || "";
  //   const cityId = localStorage.getItem("selectedCityId") || "";
  //   const genderAPI = localStorage.getItem("genderAPI") || "";
  //   const minAmount = Number(localStorage.getItem("minAmount") || "1");
  //   const maxAmount = Number(localStorage.getItem("maxAmount") || "30000");

  //   const payload = {
  //     leadId,
  //     gender: genderAPI,
  //     minAmount,
  //     maxAmount,
  //     localityId: selectedLatLng, // <-- fresh State, NOT stale localStorage
  //     cityId,
  //   };

  //   console.log("latlng >>>> --- ", selectedLatLng);
  //   // console.log("payload >>>> --- ", payload);

  //   fetchProperty(payload);
  // }, [selectedLocality, selectedLatLng]);

  useEffect(() => {
    // if (selectedLocality.length === 0) return;
    // if (selectedLatLng.length === 0) {
    //   console.log("⏳ Waiting for new coordinates...");
    //   return;
    // }

    // console.log("API CALL WITH DATA ");
    // console.log(selectedLatLng, "selectedLatLng");

    // ****** check is navigated from home screen ******
    const isAddMinMax_Amount = localStorage.getItem("is_add_max_min");

    const selectedLocalityId = localStorage.getItem("SelectedLocalityId") || "";
    const genderAPI = localStorage.getItem("genderAPI") || "";
    let maxAmountStr = localStorage.getItem("maxAmount") || "";
    let minAmountStr = localStorage.getItem("minAmount") || "";

    const leadId = localStorage.getItem("lead_profile_id") || "";
    const cityId = localStorage.getItem("selectedCityId") || "";
    const category = localStorage.getItem("category") || "";

    // Use state directly instead of reading localStorage again
    const payload = {
      leadId,
      gender: genderAPI,
      localityId: selectedLatLng,
      cityId,
      category,
      ...(isAddMinMax_Amount &&
        minAmountStr && { minAmount: Number(minAmountStr) }),
      ...(isAddMinMax_Amount &&
        maxAmountStr && { maxAmount: Number(maxAmountStr) }),
    };

    console.log("API CALL WITH DATA2 ", payload);
    fetchProperty(payload);

    // update filterAPI state
    setFilterAPI({
      leadId,
      selectedLocalityId,
      genderAPI,
      minAmount: Number(minAmountStr),
      maxAmount: Number(maxAmountStr),
      selectedLatLng,
      category,
    });
  }, [selectedLocality, selectedLatLng]);

  // View Profile API CALL

  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    console.log("1 api call trigger: >>>>", leadId);

    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  // UpdateProfileData data api call
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    if (profileData) {
      const leadId = localStorage.getItem("lead_profile_id");
      const genderAPI = localStorage.getItem("genderAPI") || "";
      const maxAmountStr = localStorage.getItem("maxAmount") || "";
      const minAmountStr = localStorage.getItem("minAmount") || "";
      const localityId = localStorage.getItem("SelectedLocalityId") || "";
      const cityId = localStorage.getItem("selectedCityId") || "";

      const id = localityId.split(",");
      // console.log(id[0], "Vikas kumar localityId");

      const updatedPayload = {
        leadId: leadId,
        full_name: profileData?.data?.full_name,
        email: profileData?.data?.email,
        phone_number: profileData?.data?.phone_number,
        gender: genderAPI,
        dob: profileData?.data?.dob,
        pref_budget_min_range: String(minAmountStr),
        pref_budget_max_range: String(maxAmountStr),
        pref_city_id: cityId,
        pref_locality_id: id[0],
      };

      // console.log("Merged update payload:", updatedPayload);
      // updatePayload(updatedPayload);
    }
  }, [profileData]); // run when viewProfile API returns

  // ************** Resize Listener ************
  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ************** Scroll to top on pathname change ************
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  // ************** Slide change handler for emblaApi ************
  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };
  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", handleSlideChange);
    }
  }, [emblaApi]);

  // Call Lead Api
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") || "";
    const gender = localStorage.getItem("gender");
    const state = "DELHI/NCR";
    const city = localStorage.getItem("selectedCity") || "";
    const selectedLocalities = JSON.parse(
      localStorage.getItem("selectedLatLng") || "[]",
    );
    const maxAmount = localStorage.getItem("maxAmount") || "30000";
    const minAmount = localStorage.getItem("minAmount") || "0";
    const localities = JSON.parse(
      localStorage.getItem("selectedLocality") ?? "[]",
    );

    if (!leadId) return;
    // if (!city) {
    //   window.location.href = "/onbording5";
    // }

    const payload = [
      { param: "GENDER", value: gender },
      { param: "STATE", value: state },
      { param: "CITY", value: city },
      { param: "LOCALITY", value: selectedLocalities },
      { param: "MAXAMOUNT", value: maxAmount },
      { param: "MINAMOUNT", value: minAmount },
      { param: "LOCALITYNAME", value: localities },
    ];

    callService("VIEW_PROPERTY", payload)
      .then((res) => {
        // console.log("✅ VIEW_PROPERTY response:", res);
      })
      .catch((err) => {
        console.error("❌ VIEW_PROPERTY failed:", err);
      });
  }, []);

  // ************** Locality from localStorage ************
  useEffect(() => {
    const storedLocality = localStorage.getItem("selectedLocality");
    if (storedLocality) {
      try {
        const parsed = JSON.parse(storedLocality);
        if (
          Array.isArray(parsed) &&
          parsed.some((item: string) => item.trim() !== "")
        ) {
          setSelectedLocality(
            parsed.filter((item: string) => item.trim() !== ""),
          );
        }
      } catch (err) {
        console.error(
          "Failed to parse selectedLocality from sessionStorage",
          err,
        );
      }
    }
  }, []);

  // old api
  // const getData = async () => {
  //   setLoading(false);

  //   // try {
  //   //   const results = await Promise.allSettled([
  //   //     axios.get(URLS.GET_COURSES),
  //   //     axios.get(URLS.GET_CATEGORIES),
  //   //     axios.get(URLS.GET_BANNERS),
  //   //   ]);

  //   //   const coursesResponse = results[0];
  //   //   const categoriesResponse = categoriesdata;
  //   //   const bannersResponse = results[2];

  //   //   if (coursesResponse.status === "fulfilled") {
  //   //     setCoursesData(coursesResponse.value.data.courses);
  //   //   } else {
  //   //     console.error("Error fetching courses:", coursesResponse.reason);
  //   //   }

  //   //   if (categoriesResponse.status === "fulfilled") {
  //   //     // setCategoriesData(categoriesResponse?.categories);
  //   //   } else {
  //   //     // console.error('Error fetching categories:', categoriesResponse?.reason);
  //   //   }

  //   //   if (bannersResponse.status === "fulfilled") {
  //   //     setBannersData(bannersResponse.value.data.banners);
  //   //   } else {
  //   //     console.error("Error fetching banners:", bannersResponse.reason);
  //   //   }
  //   // } catch (error) {
  //   //   console.error("Unexpected error:", error);
  //   // } finally {
  //   //   setLoading(false);
  //   // }
  // };
  // useEffect(() => {
  //   getData();
  // }, []);

  // component Start here

  // console.log(selectedLatLng, "=================");

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={false}
        // search={true}
        filter={false}
        // logo={true}
        title={""}
        centerImageSrc={logo}
      />
    );
  };

  const renderBottomTabBar = (): JSX.Element => {
    return <BottomTabBar />;
  };

  const renderSearchBar2 = (): JSX.Element => {
    const selectedCity = localStorage.getItem("selectedCity");
    return (
      <div className="container">
        <div className="searchBar">
          <svg.SearchSvg />
          <input
            type="text"
            placeholder="Search City, locality, landmark here"
            className="searchInput"
            // onChange={() => console.log("onchangeActive")}
            onClick={() => navigate("/onbording6")}
          />
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/onbording7")}
          >
            <FilterSvg color="#00b497" />
            {/* <FilterSvg color={"#7065F0"} /> */}
          </div>
        </div>

        {selectedCity && (
          <div
            style={{
              fontSize: "16px",
              marginTop: "10px",
              textAlign: "center",
              color: "#333",
              fontWeight: "500",
            }}
          >
            Get the best PGs in{" "}
            <span style={{ color: "#000", fontWeight: "600" }}>
              {selectedCity}
            </span>
            !
          </div>
        )}

        {selectedLocality.length > 0 && (
          <p style={{ fontSize: "13px", marginTop: "20px" }}>
            Selected Locality
          </p>
        )}
        <div className="location-tag-group" style={{ gap: "5px" }}>
          {/* <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div> */}
          {selectedLocality?.map((city: string, index: number) => (
            <div
              key={index}
              className="location-tag-wrapper"
              style={{
                padding: "5px 10px",
                marginBottom: "0",
                background: "none",
                backgroundColor: `var(--secondary-color)`,
                color: "white",
              }}
            >
              {city}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const offerBanner = (): JSX.Element => {
    // console.log("================");
    // console.log(homeimg);
    return (
      <div className="container" style={{ marginBottom: 0, marginTop: 20 }}>
        <div className="property-card">
          <div className="card-content">
            <img src={homeimg} alt="House" className="house-image" />
            <div className="text-section">
              <p className="card-text">
                Explore your recent property searches for rentals and PGs
                tailored to your preferences.
              </p>
              <button
                className="get-started-btn"
                onClick={() => navigate("/home")}
              >
                View Recent Searches <span className="arrow">↗</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderBanner = (): JSX.Element => {
    return (
      <div className="container" id="serachBanner">
        <div
          className="img-container"
          style={{
            borderRadius: "9px",
            overflow: "hidden",
            height: "max-content",
          }}
          // style={{ borderRadius: "9px", overflow: "hidden", height: "160px" }}
        >
          <img
            src={serachBanner}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
    );
  };

  const renderCards = (start: number, end?: number) => {
    return propertyData?.data
      ?.slice(start, end)
      ?.map((course: any, index, array) => {
        const isLast = index === array.length - 1;
        return (
          <SerachResultCard
            key={course?.id || index}
            course={course}
            isLast={isLast}
            section="top rated"
            index={index}
          />
        );
      });
  };

  const serachResult = (): JSX.Element => {
    // console.log(propertyData?.data.length);

    const results = propertyData?.data || [];
    // const [visibleCount, setVisibleCount] = React.useState(20);

    const handleLoadMore = () => {
      setVisibleCount((prev) => prev + 20);
    };

    if (propertyLoading) {
      return <CustomLoader />;
    }

    if (!results || results.length === 0) {
      return (
        <>
          <div
            style={{ marginTop: 30, display: "flex", justifyContent: "center" }}
          >
            <img
              src={require("../../assets/nestfin/noResult.jpg")}
              alt="No Results"
              style={{ maxWidth: "300px", width: "100%" }}
            />
          </div>
          {renderReelReview(properties?.properties)}
          {renderBanner()}
        </>
      );
    }

    const visibleResults = results.slice(0, visibleCount);
    const hasMore = visibleCount < results.length;

    return (
      <div style={{ marginBottom: 0, marginTop: 30 }}>
        {/* ✅ First 2 cards */}

        {visibleResults.slice(0, 2).map((_, index) => (
          <div key={index}>{renderCards(index, index + 1)}</div>
        ))}

        {/* ✅ Banner after first 2 */}
        {renderBanner()}

        {/* ✅ Next 2 cards (index 2–3) */}
        {visibleResults.slice(2, 4).map((_, index) => (
          <div key={index + 2}>{renderCards(index + 2, index + 3)}</div>
        ))}

        {/* ✅ Reel review */}
        {renderReelReview(properties?.properties)}

        {/* ✅ Remaining cards (from index 4 onward) */}
        {visibleResults.slice(4).map((_, index) => (
          <div key={index + 4}>{renderCards(index + 4, index + 5)}</div>
        ))}

        {/* ✅ Load More Button */}
        {hasMore && (
          <div style={{ textAlign: "center", margin: "30px 0" }}>
            <button
              onClick={handleLoadMore}
              style={{
                background: "#014d4e",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Load More
            </button>
          </div>
        )}
      </div>
    );
  };

  const renderReelReview = (courses: any[]): JSX.Element => {
    // console.log(propertyData?.data, "propertyData?.data form to selling pg in noida");

    return (
      <div style={{ marginTop: 40 }}>
        {propertyData &&
          Array.isArray(propertyData?.data) &&
          propertyData?.data?.length > 0 && (
            <components.BlockHeading
              title="Top Selling PG"
              containerStyle={{ marginBottom: 12, padding: "0 20px" }}
            />
          )}

        {/* <Swiper spaceBetween={16} slidesPerView="auto">
          {propertyData?.data?.slice(0,6).map?.((item, index) => (
            <SwiperSlide
              key={item.property_id}
              style={{
                width: 200,
                height: 355,
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "#000",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => {
                // console.log("item ========>>> ", item);
                    const localitySlug =
                    item?.locality_name
                      ?.toLowerCase()
                      ?.replace(/\s+/g, "-") || "locality";
                  const citySlug =
                    item?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                    "city";
                  const propertySlug =
                    item?.property_name
                      ?.toLowerCase()
                      ?.replace(/\s+/g, "-") || "property";

                  const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}`;
                navigate(customUrl, { state: { item } });
              }}
            >
              <img
                src={
                  item?.photos &&
                  item?.photos.length > 0 &&
                  item?.photos[0]?.photo_path
                    ? item.photos[0]?.photo_path
                    : fallBackImg
                }
                alt="Property Image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 10,
                }}
              />

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  padding: "10px",
                  fontSize: 12,
                  lineHeight: 1.4,
                }}
              >
                <div
                  style={{
                    marginBottom: 4,
                    // whiteSpace: "nowrap",
                    overflow: "hidden",
                    // textOverflow: "ellipsis",
                    fontSize:"18px"
                  }}
                >
                  {item?.property_name} 
                </div>
                <p style={{ fontWeight: 600, fontSize:"12px" }}>Starting from</p>
                <div style={{ marginBottom: 2, fontSize:"16px", fontWeight:"600" }}>
                  {" "}

                 ₹{formatIndianNumber(item?.minimum_rent)} / month
                </div>
                  {
                    (item?.locality_name || item?.city_name ) && (
                      <div style={{fontSize:"14px"}}>

                        {item?.locality_name} 
                        {
                          item?.locality_name && item?.city_name ? ", " : ""} {item?.city_name}
                      </div>
                    )
                  }


              </div>
<div
  style={{
    position: "absolute",
    top: "10px",
    right: "8px",
    display: "flex",
    gap: "8px", 
    fontWeight: "bold",
  }}
>
  <button
    style={{
      backgroundColor: "var(--secondary-color)",
      padding: "5px 10px",
      borderRadius: "8px",
      color: "white",
      cursor: "pointer",
      fontSize: "10px",
      letterSpacing: "1px",
    }}
  >
    {item?.category?.toUpperCase()}
  </button>

  <button
    style={{
      backgroundColor: "var(--secondary-color)",
      padding: "5px 10px",
      borderRadius: "8px",
      color: "white",
      cursor: "pointer",
      fontSize: "10px",
      letterSpacing: "1px",
    }}
  >
    {item?.gender_allowed?.toUpperCase()}
  </button>
</div>
            </SwiperSlide>
          ))}
        </Swiper> */}
        <Swiper spaceBetween={16} slidesPerView="auto">
          {propertyData?.data?.slice(0, 6)?.map?.((item, index) => (
            <SwiperSlide
              key={item.property_id}
              style={{
                width: 200,
                height: 355,
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "#000",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => {
                const localitySlug =
                  item?.locality_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                  "locality";
                const citySlug =
                  item?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                  "city";
                const propertySlug =
                  item?.property_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                  "property";
                const propertyId = `?id=${btoa(item?.property_id) || ""}`;

                const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;
                navigate(customUrl, { state: { item } });
              }}
            >
              {/* Replace <img> with loader-enabled component */}
              <ImageWithLoader
                src={
                  item?.photos?.length > 0 && item?.photos[0]?.photo_path
                    ? item.photos[0].photo_path
                    : fallBackImg
                }
                alt="Property Image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 10,
                }}
              />

              {/* Bottom Card Details */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  padding: "10px",
                  fontSize: 12,
                  lineHeight: 1.4,
                }}
              >
                <div
                  style={{
                    marginBottom: 4,
                    overflow: "hidden",
                    fontSize: "18px",
                  }}
                >
                  {item?.property_name}
                </div>

                <p style={{ fontWeight: 600, fontSize: "12px" }}>
                  Starting from
                </p>

                <div
                  style={{
                    marginBottom: 2,
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  ₹{formatIndianNumber(item?.minimum_rent)} / month
                </div>

                {(item?.locality_name || item?.city_name) && (
                  <div style={{ fontSize: "14px" }}>
                    {item?.locality_name}
                    {item?.locality_name && item?.city_name ? ", " : ""}
                    {item?.city_name}
                  </div>
                )}
              </div>

              {/* Top Right Badges */}
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "8px",
                  display: "flex",
                  gap: "5px",
                  fontWeight: "bold",
                }}
              >
                {item?.category?.length && (
                  <button style={buttonTagStyle}>
                    {item?.category?.toUpperCase()}
                  </button>
                )}
                <button style={buttonTagStyle}>
                  {item?.gender_allowed?.toUpperCase()}
                </button>

                <button style={buttonTagStyle}>
                  {(!!item?.is_meal_provided &&
                    item?.is_meal_provided?.toLowerCase()) == "yes"
                    ? "MEAL"
                    : "NO MEAL"}
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main>
        {renderSearchBar2()}
        {/* {cardFormat()} */}
        {offerBanner()}
        {serachResult()}
        {/* {renderReelReview()} */}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
